import React from 'react';
import { LayoutChangeEvent, View, ViewStyle } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface ContainerProps {
    children?: React.ReactNode;
    style?: ViewStyle;
    /**
     * Invoked on mount and layout changes with
     *
     * {nativeEvent: { layout: {x, y, width, height}}}.
     */
    onLayout?: ((event: LayoutChangeEvent) => void) | undefined;
}

export default function Container(props: ContainerProps) {
    const { styles } = useStyles(stylesheet);

    return <View style={[styles.container, props.style]} onLayout={props.onLayout}>
        {props.children}
    </View>;
}

const stylesheet = createStyleSheet(() => ({
    container: {
        flex: 1,
    },
}));
